// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1_YYM","choiceBoxes":"toolbarselects_choiceBoxes__2_QM9","simpleField":"toolbarselects_simpleField__2vAta"};